import React from 'react';
import { TextField } from '@material-ui/core';
import * as lib from '~/dependencies';
import { FormControlList, SelectList } from './styles';

export default function Select({
  title,
  values,
  value,
  valueList,
  handleChange,
  selectedOption,
  PaperComponent,
  labelOption,
  multiple,
  disabled,
  groupBy,
  ...rest
}) {
  return (
    <FormControlList>
      <SelectList
        {...rest}
        multiple={multiple}
        disabled={disabled}
        id={`tags-standard-${title}`}
        value={multiple ? values : value}
        options={valueList}
        getOptionSelected={selectedOption}
        getOptionLabel={labelOption}
        groupBy={groupBy}
        filterSelectedOptions
        onChange={handleChange}
        size="small"
        PaperComponent={PaperComponent}
        renderInput={params => (
          <TextField
            {...params}
            variant="standard"
            label={title}
            placeholder=""
          />
        )}
      />
    </FormControlList>
  );
}

Select.defaultProps = {
  values: [],
  value: {},
  valueList: [],
  disabled: false,
  handleChange: () => {},
  selectedOption: () => {},
  labelOption: () => {},
  groupBy: () => {},
  multiple: false,
  PaperComponent: () => {},
};

Select.propTypes = {
  title: lib.PropTypes.string.isRequired,
  value: lib.PropTypes.shape({}),
  values: lib.PropTypes.arrayOf(lib.PropTypes.shape({})),
  disabled: lib.PropTypes.bool,
  valueList: lib.PropTypes.arrayOf(lib.PropTypes.shape({})),
  handleChange: lib.PropTypes.func,
  selectedOption: lib.PropTypes.func,
  labelOption: lib.PropTypes.func,
  groupBy: lib.PropTypes.func,
  PaperComponent: lib.PropTypes.func,
  multiple: lib.PropTypes.bool,
};
